import { AppDispatch } from 'src/store';
import { createAction } from '@reduxjs/toolkit';

import { fetchSiteByIdRequest, updateSiteRequest } from './requestHandlers';
import { ISite } from './types';

export const loadSiteDetailsStart = createAction('sites/details/load/start');
export const loadSiteDetailsSuccess = createAction<ISite>('sites/details/load/success');
export const resetSiteDetails = createAction('sites/details/reset');

export const loadSiteDetails = (id: string) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    dispatch(loadSiteDetailsStart());
    const data = await fetchSiteByIdRequest(id);

    if (data) {
      dispatch(loadSiteDetailsSuccess(data));
    }

    return true;
  };
};

export const updateSite = (data: Partial<ISite>) => {
  return async (dispatch: AppDispatch): Promise<ISite | null> => {
    const res = await updateSiteRequest(data);
    if (res) {
      dispatch(loadSiteDetailsSuccess(res));
    }
    return res;
  };
};
